export default __webpack_public_path__ + "static/media/TR.0d5219c5.svg";